import React, {useState, useEffect} from "react";
// import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import axios from "axios";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import {ProductInfoColumn} from "../ColumnsFormatter/ProductInfoColumn";
import {fetchAllSuppliers, fetchSuppliers, fetchSupplierClients} from "../AdminPagesCrud";
import EditOrAddProduct from "./EditOrAddProduct";
import { ImportProductsModal } from "./ImportProductsModal";
import {UserActiveColumn} from "../ColumnsFormatter/UserInfoColumn";
import {ProductSupplierColumn} from "../ColumnsFormatter/ProductSupplierFormatter";
import {ProductCategoryColumn} from "../ColumnsFormatter/ProductCategoryFormatter";

function ProductsAdminPage(props) {
    const { supplierClients } = props
    // console.log("Supplier Clients from products admin page: ", supplierClients)
    const initialValues = {
        name: "",
        sku: "",
        description: "",
        storeCode: "",
        supplierId: "",
        categoryId: "",
        unitMeasurement: "CS",
        units: 1,
        unitSize: 1,
        lastPoCost: 0,
        latestLandedCost: 0,
        lowerPriceMargin: 0,
        price: 0,
        discountPrice: 0,
        fob: 0,
        comment: "",
        imagePath: "",
        qtyAvailable: 0,
        qtyOnHand: 0,
        isActive: true,
        defaultUnitOfMeasurement: {},
        unitsOfMeasurement: [],
        exclusiveStoreIds: []
    };

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const initialData = {
        data: [],
        totalCount: 0,
        pageSize: 10
    }

    const [data,setData] = useState(initialData)
    const [selectedProduct, setSelectedProduct] = useState(initialValues)
    const [openProductForm, setOpenProductForm] = useState(false)
    const [isNew, setIsNew] = useState(true)
    const [snackbarProductAdmin, setSnackbarProductAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [openImportModal, setOpenImportModal] = useState(false)

    const fetchProducts = (queryParams) => {
        // Authorization head should be fulfilled in interceptor.
        setIsLoading(true)
        const options = {
            headers: { 'x-auth-token': accessToken},
            validateStatus: status => status < 500,
            params: queryParams
        }
        axios.get(process.env.REACT_APP_API_URL + '/products/tenant', options).then(response =>{
            let temp = response.data;

            console.log("response: ", response)
            
            setData(temp)
            setIsLoading(false)
        }).catch(error => {
            console.log(error);
            setIsLoading(false)
        });
    }


    const columns = [
        {
            dataField: "name",
            text: "Name",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: ProductInfoColumn,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedProduct(row)
                    setIsNew(false)
                    setOpenProductForm(true)
                }
            },
        },
        {
            dataField: "brand",
            text: "Brand",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "supplierName",
            text: "Supplier",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: ProductSupplierColumn
        },
        {
            dataField: "category",
            text: "Category",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: ProductCategoryColumn
        },
        {
            dataField: "sku",
            text: "SKU",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "isActive",
            text: "Is Active",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: UserActiveColumn
        },
    ];

    const sizePerPageList = [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "15", value: 15 }
    ]

    const initialFilter = {
        filter: {
            name:"",
            category:"",
            sku: "",
            supplierName: ""
        },
        sortOrder: "asc",
        sortField: "name",
        pageNumber: 1,
        pageSize: 10
    }

    const sorting = [{dataField: "name",order:"asc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center"

    const prepareFilter = (queryParams,values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.name = searchText ?? "";
        filter.category = searchText ?? "";
        filter.sku = searchText ?? "";
        filter.supplier = searchText ?? "";


        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            {openProductForm ?
                <EditOrAddProduct product={selectedProduct} setOpenProductForm={setOpenProductForm} isNew={isNew} setIsNew={setIsNew}
                                  setShowSnackbar={setSnackbarProductAdmin} showSnackbar={snackbarProductAdmin} 
                                  setSelectedProduct={setSelectedProduct} initialValues={initialValues} supplierClients={supplierClients}/>
                :
                <Card>
                    <CardHeader title="Products Admin">
                        <CardHeaderToolbar>
                            <button
                                type="button"
                                className="btn btn-success mr-3"
                                onClick={() => setOpenImportModal(true)}
                            >
                                Import Products
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setOpenProductForm(true)}
                            >
                                New Product
                            </button>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <PaginationTable
                            data={data}
                            columns={columns}
                            pagination={pagination}
                            isLoading={isLoading}
                            sorting={sorting}
                            tableClasses={tableClasses}
                            fetcher={fetchProducts}
                            filterFunction={prepareFilter}
                            initialFilter={initialFilter}/>
                    </CardBody>
                </Card>
            }
            <ImportProductsModal
                show={openImportModal}
                onClose={() => setOpenImportModal(false)}
                onSuccess={() => { fetchProducts(initialFilter); setOpenImportModal(false); }}
                accessToken={accessToken}
            />
        </>
    );
}

export default injectIntl(ProductsAdminPage);